import { defineComponent as _defineComponent } from 'vue'
import { onBeforeUnmount, onMounted, ref } from 'vue';
import { EventBus } from '@/helpers/EventBusHelper';
import { EventBusEvents } from '@/enums/global/EventBusEvents';
import ProductCombination from '@/components/views/productView/ProductCombination.vue';

/* === Props & State === */

export default /*#__PURE__*/_defineComponent({
  __name: 'CombinationsEditPopup',
  props: {
    productData: { required: true },
},
  setup(__props) {



const visible = ref(false);

function openPopup() {
    visible.value = true;
}

function closePopup() {
    visible.value = false;
}

/* === Lifecycle === */
onMounted(() => {
    EventBus.$on(EventBusEvents.openCombinationsEditPopup, openPopup);
    EventBus.$on(EventBusEvents.closeContactPopup, closePopup);
});

onBeforeUnmount(() => {
    EventBus.$off(EventBusEvents.openCombinationsEditPopup, openPopup);
    EventBus.$off(EventBusEvents.closeContactPopup, closePopup);
});

return { __sfc: true,visible, openPopup, closePopup, ProductCombination }
}

})